import { motion } from "framer-motion";
import { X } from "lucide-react";

/* Reusable centered modal with backdrop blur, close button and scale-in animation.
   Used by Clinic Pulse demo modal + Juvonno/Jane integration page demo modal. */
export const ModalShell = ({ onClose, children, wide = false }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.2 }}
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
    onClick={onClose}
  >
    <motion.div
      initial={{ scale: 0.95, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0.95, opacity: 0 }}
      transition={{ duration: 0.25 }}
      className={`relative max-h-[95vh] w-full overflow-y-auto rounded-3xl border border-border bg-background shadow-2xl ${wide ? "max-w-5xl" : "max-w-4xl"}`}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        data-testid="modal-close"
        className="absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center justify-center rounded-full bg-background/80 ring-1 ring-inset ring-border transition-colors hover:bg-secondary"
      >
        <X className="h-4 w-4" />
      </button>
      {children}
    </motion.div>
  </motion.div>
);
